/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '../button';
import { slideTopAndLegacyTransition } from './__fixtures__';

type OmitProps = 'title' | 'error';

const defaults = {
  title: 'Confirm',
  positive: 'Okay',
  negative: 'Cancel',
  disabled: false,
};

interface Props extends Omit<DialogProps, OmitProps> {
  title: string;
  positive: string;
  onPositive: () => void;
  negative?: string;
  onNegative?: () => void;
  disabled?: boolean;
  slideTop?: boolean;
}

export default function ConfirmModal({
  title = defaults.title,
  positive = defaults.positive,
  negative = defaults.negative,
  disabled = defaults.disabled,
  onPositive,
  onNegative,
  slideTop,
  ...props
}: Props) {
  return (
    <div>
      <Dialog
        {...props}
        {...slideTopAndLegacyTransition(slideTop, false)}
        maxWidth={props.maxWidth ?? 'xs'}
        fullWidth
        open={props.open}
        onClose={onNegative}
        disableEnforceFocus
      >
        <DialogTitle sx={{ fontWeight: 700 }}>
          {title}
        </DialogTitle>
        <DialogContent data-testid="confirm-dialog-description">
          {props.children}
        </DialogContent>
        <DialogActions>
          <>
            {onNegative && (
              <Button sx={{ color: '#757575' }} onClick={onNegative}>
                {negative}
              </Button>
            )}
            <Button onClick={onPositive} disabled={disabled} autoFocus>
              {positive}
            </Button>
          </>
        </DialogActions>
      </Dialog>
    </div>
  );
}
